import { render, staticRenderFns } from "./newbanner.vue?vue&type=template&id=717e523d&scoped=true"
import script from "./newbanner.vue?vue&type=script&lang=js"
export * from "./newbanner.vue?vue&type=script&lang=js"
import style0 from "./newbanner.vue?vue&type=style&index=0&id=717e523d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e523d",
  null
  
)

export default component.exports